<template>
    <div class="flex flex-col bg-white">
        <div class="grid grid-cols-7 p-2 gap-4">
            <span>gatewayId</span>
            <span>Название</span>
            <span>Активен</span>
            <span>Настройки</span>
        </div>
        <div class="grid grid-cols-7 border-t p-2 gap-4" v-for="row in data">
            <div>{{ row.gatewayId }}</div>
            <div>{{ row.name }}</div>
            <v-toggle v-model="row.isActive"/>
            <div>{{ row.credentials }}</div>
        </div>
    </div>
</template>

<script>

import VToggle from '@/Components/Toggle';

export default {
    components: {
        VToggle,
    },
    props: {
        data: Object,
    },
};
</script>
